import router from "./router.js"
import auth from "./services/auth.js"
import bus from "./services/bus.js"
import Notifications from "./views/Notifications.vue"
import UpdatedNotice from "./views/UpdatedNotice.vue"

export default {
  name: "app",
  router: router,
  components: {
    Notifications,
    UpdatedNotice,
  },

  data() {
    return {
      state: "login",
      navigationDrawer: false,
    }
  },

  computed: {
    fullname() {
      return [auth.member.firstname, auth.member.lastname].join(" ")
    },
  },

  methods: {
    isAuthenticated() {
      return auth.isAuthenticated()
    },

    navigateTo(path) {
      router.push(path)
      this.navigationDrawer = false
    },

    logout() {
      auth.logout()
      router.push("/login")
      bus.$emit("auth:logout")
    },
  },
}
